import { render, staticRenderFns } from "./bikes.vue?vue&type=template&id=66657e63&"
import script from "./bikes.vue?vue&type=script&lang=js&"
export * from "./bikes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports